"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("@kyruus/button");
var _useIsMobileScreen = _interopRequireDefault(require("../lib/hooks/useIsMobileScreen"));
var _styles = require("./styles");
const propTypes = {
  maxAvailabilitiesToDisplay: _propTypes.default.number.isRequired,
  showAvailabilitiesBtnText: _propTypes.default.node.isRequired,
  onClickShowAvailabilities: _propTypes.default.func.isRequired,
  showAvailabilitiesBtnAriaLabel: _propTypes.default.string,
  shouldHideBelowScreenMedium: _propTypes.default.bool
};
const HiddenAvailabilityTiles = _ref => {
  let {
    maxAvailabilitiesToDisplay,
    showAvailabilitiesBtnText,
    onClickShowAvailabilities,
    showAvailabilitiesBtnAriaLabel,
    shouldHideBelowScreenMedium = true
  } = _ref;
  const isMobile = (0, _useIsMobileScreen.default)();
  if (isMobile && !shouldHideBelowScreenMedium) {
    return /*#__PURE__*/_react.default.createElement(_button.Button, {
      mode: "secondary",
      onClick: onClickShowAvailabilities,
      "aria-label": showAvailabilitiesBtnAriaLabel,
      "data-testid": "AvailabilityTiles__ShowAvailabilities__Mobile"
    }, showAvailabilitiesBtnText);
  }
  const skeletonSlots = [];
  for (let i = 0; i <= maxAvailabilitiesToDisplay; i++) {
    skeletonSlots.push(/*#__PURE__*/_react.default.createElement(_styles.SkeletonSlot, {
      key: i
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_styles.FlexContainer, {
    "data-testid": "AvailabilityTiles__Hidden",
    justifyContent: "center",
    shouldHideBelowScreenMedium: shouldHideBelowScreenMedium
  }, /*#__PURE__*/_react.default.createElement(_styles.OverlaidCtaBtn, {
    "data-testid": "AvailabilityTiles__ShowAvailabilities",
    onClick: onClickShowAvailabilities,
    "aria-label": showAvailabilitiesBtnAriaLabel
  }, showAvailabilitiesBtnText), skeletonSlots);
};
HiddenAvailabilityTiles.propTypes = propTypes;
var _default = exports.default = HiddenAvailabilityTiles;
HiddenAvailabilityTiles.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "HiddenAvailabilityTiles",
  "props": {
    "shouldHideBelowScreenMedium": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "maxAvailabilitiesToDisplay": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "showAvailabilitiesBtnText": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "onClickShowAvailabilities": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "showAvailabilitiesBtnAriaLabel": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};